import doctors from '../../api/doctors'
import patients from "../../api/patients";
import follow_ups from "../../api/follow_ups";

const errors = {
    GET_ALL_DOCTORS_LOADING_ERROR: 'Erreur lors du chargement des médecins, merci de réessayer',
    GET_DOCTOR_LOADING_ERROR: 'Erreur lors du chargement du médecin, merci de réessayer',
    CREATE_DOCTOR_ERROR: 'Erreur lors de la création du médecin, merci de réessayer',
    UPDATE_DOCTOR_ERROR: 'Erreur lors de la mise à jour du médecin, merci de réessayer',
}

const success = {
    CREATE_DOCTOR_SUCCESS: {
        title: "Succès",
        content: "Médecin créé avec succès"
    },
    UPDATE_DOCTOR_SUCCESS: {
        title: "Succès",
        content: "Médecin mis à jour"
    }
}


// initial state
const state = {
    all: [],
    selectedDoctor: {
        id: null,
        name: '',
        address: '',
        phone: '',
        email: '',
        postcode: '',
        city: '',
        country: 'Suisse',
    },
    form: {
        name: '',
        address: '',
        phone: '',
        email: '',
        postcode: '',
        city: '',
        country: 'Suisse',
    },
}

// getters
const getters = {
}

// actions
const actions = {
    getAllDoctors ({ state, commit, rootState }) {
        doctors.getDoctors(rootState.axios).then(result => {
            commit('setDoctors', result.data.doctors)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_ALL_DOCTORS_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    loadDoctorForm({ state, commit, rootState }) {
        doctors.get(state.selectedDoctor.id, rootState.axios).then(result => {
            commit('initDoctorForms', result.data.doctor)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_DOCTOR_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    createDoctor({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            doctors.add(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_DOCTOR_SUCCESS.title, content: success.CREATE_DOCTOR_SUCCESS.content
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_DOCTOR_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateDoctor({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            doctors.update(state.selectedDoctor.id, state.form, rootState.axios).then(result => {
                commit('setSelectedDoctor', result.data.doctor)
                commit('notifications/showSuccess', {
                    title: success.UPDATE_DOCTOR_SUCCESS.title, content: success.UPDATE_DOCTOR_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_DOCTOR_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    postDeleteDoctor({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            doctors.delete(state.selectedDoctor.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_DOCTOR_SUCCESS.title, content: success.UPDATE_DOCTOR_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_DOCTOR_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    exportAllDoctors({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            doctors.fullExport(rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.GET_ALL_DOCTORS_LOADING_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
}

// mutations
const mutations = {
    setDoctors (state, doctors) {
        state.all = doctors
    },
    setFormName (state, value) {
        state.form.name = value
    },
    setFormEmail (state, value) {
        state.form.email = value
    },
    setFormPhone (state, value) {
        state.form.phone = value
    },
    setFormAddress (state, value) {
        state.form.address = value
    },
    setFormPostcode (state, value) {
        state.form.postcode = value
    },
    setFormCity (state, value) {
        state.form.city = value
    },
    setFormCountry (state, value) {
        state.form.country = value
    },
    setSelectedDoctor(state, value) {
        state.selectedDoctor = value
    },
    setSelectedDoctorId(state, value) {
        state.selectedDoctor.id = value
    },
    initDoctorForms(state, data) {
        state.form.name = data.name
        state.form.email = data.email
        state.form.phone = data.phone
        state.form.address = data.address
        state.form.city = data.city
        state.form.country = data.country
        state.form.postcode = data.postcode
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
